import { render, staticRenderFns } from "./EditFolderModal.vue?vue&type=template&id=6db54d76"
import script from "./EditFolderModal.vue?vue&type=script&lang=js"
export * from "./EditFolderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports